import * as Const from '../constants/actionConstants';
import * as BusConst from '../constants';

import State from '../interfaces/states/SubscriptionState';
import { SubscriptionPeriod } from '../../../constants';

const initState: State = {
  product: null,
  package_: null,
  dateTo: null,
  dateFrom: new Date(),
  dateError: null,
  typePayment: BusConst.INVOICE,
  planePrice: 0,
  fieldsArea: '',
  formReady: false,
  subscriptionPeriod: SubscriptionPeriod.ANNUAL,
  shouldCreatePayment: false,
};

export default function subscription (state: State = initState, action): State {
  switch (action.type) {

    case Const.SUB_FORM_INIT:
      return {
        ...initState,
      };

    case Const.SUB_CHANGE_PRODUCT:
      return {
        ...state,
        product: action.product,
      };

    case Const.SUB_CHANGE_PACKAGE:
      return {
        ...state,
        package_: action.package_,
      };

    case Const.SUB_CHANGE_DATE_TO:
      return {
        ...state,
        dateTo: action.dateTo,
      };

    case Const.SUB_CHANGE_DATE_FROM:
      return {
        ...state,
        dateFrom: action.dateFrom,
      };

    case Const.SUB_DATE_ERROR:
      return {
        ...state,
        dateError: action.dateError,
      };

    case Const.SUB_CHANGE_TYPE_PAYMENT:
      return {
        ...state,
        typePayment: action.typePayment,
      };

    case Const.SUB_CHANGE_PLANE_PRICE:
      return {
        ...state,
        planePrice: action.planePrice,
      };

    case Const.SUB_CHANGE_FIELDS_AREA:
      return {
        ...state,
        fieldsArea: action.fieldsArea,
      };

    case Const.SUB_CHANGE_SUBSCRIPTION_PERIOD:
      return {
        ...state,
        subscriptionPeriod: action.period,
      };

    case Const.SUB_CHANGE_SHOULD_CREATE_PAYMENT:
      return {
        ...state,
        shouldCreatePayment: action.shouldCreatePayment,
      };

    case Const.SUB_CHANGE_FORM_READY:
      return {
        ...state,
        formReady: action.formReady,
      };

    default:
      return state;
  }
}
